/**
 * The author's public portfolio works in profile order: the works in
 * `featuredPortfolioOrder` (profile publicData, `[{ id, order }]`) first,
 * sorted by `order`, then the rest in their input order. Private works and
 * listings that are not portfolio works are dropped.
 *
 * Used by the profile page (ProfilePage.duck). The listing page's "Related
 * work" section shows the picked or newest works instead (relatedListings).
 */
export const orderPortfolioWorks = (listings, featuredPortfolioOrder) => {
  const order = Array.isArray(featuredPortfolioOrder) ? featuredPortfolioOrder : [];

  const unsortedPortfolioWorks = (listings || []).filter(
    l =>
      l?.attributes?.publicData?.listingType === 'portfolioWork' &&
      !l?.attributes?.publicData?.privateWork
  );

  if (order.length === 0) {
    return unsortedPortfolioWorks;
  }

  const featuredWorks = [];
  const remainingWorks = [];

  unsortedPortfolioWorks.forEach(work => {
    const workId = work?.id?.uuid || work?.id;
    const orderEntry = order.find(entry => entry.id === workId);
    if (orderEntry) {
      featuredWorks.push({ work, order: orderEntry.order });
    } else {
      remainingWorks.push(work);
    }
  });

  featuredWorks.sort((a, b) => a.order - b.order);
  return [...featuredWorks.map(fw => fw.work), ...remainingWorks];
};
